export enum RutterIntegrationConnectionType {
    Accounting = 'accounting',
    Commerce = 'commerce',
}
